import { Alert, AlertTitle } from '@mui/material';

/**
 * Un fallo de Watchtower, explicado.
 *
 * El 403 tiene tratamiento propio porque no es una avería: desde que `/api/obs/*`
 * exige `watchtower.view` en vez del rol de admin, un administrador de siempre puede
 * llegar hasta aquí y no poder ver nada. Decirle «Error cargando eventos (403)» lo
 * manda a buscar un fallo que no existe.
 *
 * Se llega con permisos revocados a mitad de sesión, o con una sesión vieja: cuando
 * `permissions` está vacío en localStorage, `hasPermission` cae al rol y deja pasar a
 * cualquier admin, así que la puerta de `RequirePermission` no basta.
 */
export const ObsError = ({ error, context = 'los datos' }) => {
  if (!error) return null;

  if (error.status === 403) {
    return (
      <Alert severity="info" sx={{ m: 2 }}>
        <AlertTitle>Watchtower necesita un permiso aparte</AlertTitle>
        Ver la observabilidad exige <code>watchtower.view</code>, que por defecto solo
        tiene el super-administrador. Puede concedértelo desde Usuarios → Editar
        permisos. Si acaban de dárselo, recarga la página.
      </Alert>
    );
  }

  if (error.status === 401) {
    return (
      <Alert severity="warning" sx={{ m: 2 }}>
        Tu sesión ha caducado. Vuelve a iniciar sesión.
      </Alert>
    );
  }

  return (
    <Alert severity="error" sx={{ m: 2 }}>
      No se pudieron cargar {context} ({error.status || 'sin respuesta del servidor'}).
    </Alert>
  );
};

export default ObsError;
